import { Icon } from "@chakra-ui/react";
import { FiArrowUpRight } from "react-icons/fi";

import { NavButton } from "../nav-button";

export const DiscordSupportButton = () => (
  <NavButton
    href="https://discord.gg/plume-network"
    target="_blank"
    rel="noopener noreferrer"
    textDecoration="none"
  >
    Discord Support
    <Icon as={FiArrowUpRight} boxSize={4} />
  </NavButton>
);
